export default "__VITE_ASSET__sKD$bHZX__"